<template>
    <AppSection>
        <template #body>
            <div class="container">
                <section class="banner" :style="`background-image: url('${params.background}')`"
                         v-if="params">
                    <div class="banner__in">
                        <div class="banner__title">{{ params.title }}</div>
                        <div class="banner__description">{{ params.description }}</div>
                        <a class="banner__button" :href="params.url">
                            <ABtn color="#fff" fill="#000" class=" dark" :label="params.buttonText" />
                        </a>
                    </div>
                </section>
            </div>
        </template>
    </AppSection>
</template>

<script>
import AppSection from "../AppSection";
import {ABtn} from "../ui";

export default {
    name: "BannerSection",
    components: {AppSection, ABtn},
    props: ['params'],
}
</script>

<style scoped lang="scss">
.banner {
    background-size: cover;
    color: #fff;
    margin: 55px 0;
    width: 100%;

    &__in {
        padding: 50px 60px;
        max-width: 50%;

        @include tablet {
            max-width: 100%;
        }
    }

    &__title {
        font-weight: 600;
        font-size: 40px;
        line-height: 44px;
        margin-bottom: 20px;
    }

    &__description {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 36px;
    }
}
</style>